import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { hexToRgb, rgbDataURL } from 'corporate-utils';

import { CardGridProdotti } from '../../../models/auto-generated-strapi-types/types/components/CardGridProdotti';
import { getStrapiMedia } from '../../../utils/media';

import {
  CardContainerStyled,
  CardContentContainerStyled,
  CardImageContainerStyled,
  CardLayerStyled,
  CardStyled,
  Title,
} from './CardGrid.style';
import { DEFAULT_IMAGE } from '../../../models/domain/const';
import ImageWithFallback from '../../image-with-fallback/ImageWithFallback';

interface CardGridProdottiExtended extends CardGridProdotti {
  addGradient?: any;
}
interface IProps {
  data: CardGridProdottiExtended;
}

const CardGrid: React.FC<IProps> = ({ data }) => {
  const { title, image, overlayColor, link, overlayColorHover, addGradient } =
    data ?? {};
  const router = useRouter();

  return (
    <CardContainerStyled>
      <CardImageContainerStyled>
        {image && image.data && image.data.attributes && (
          <ImageWithFallback
            layout="fill"
            objectFit="cover"
            placeholder="blur"
            blurDataURL={
              overlayColor
                ? rgbDataURL(
                  hexToRgb(overlayColor)?.[0],
                  hexToRgb(overlayColor)?.[1],
                  hexToRgb(overlayColor)?.[2]
                )
                : rgbDataURL(
                  hexToRgb('ffffff')?.[0],
                  hexToRgb('ffffff')?.[1],
                  hexToRgb('ffffff')?.[2]
                )
            }
            src={getStrapiMedia(image?.data?.attributes?.url ?? '')}
            alt={image?.data?.attributes?.alternativeText || ''}
            fallbackSrc={DEFAULT_IMAGE}
          />
        )}
      </CardImageContainerStyled>
      {addGradient && <CardLayerStyled />}
      <CardContentContainerStyled>
        <CardStyled
          overlay={overlayColor}
          overlayHover={overlayColorHover}
          onClick={(e: any) => {
            e.preventDefault();
            router.push(
              { pathname: link },
              { pathname: link },
              { locale: router.locale, shallow: false }
            );
          }}
        >
          <Link href={link || '/'} passHref prefetch={false}>
            <Title
              onClick={(e: any) => {
                e.preventDefault();
              }}
            >
              {title}
            </Title>
          </Link>
        </CardStyled>
      </CardContentContainerStyled>
    </CardContainerStyled>
  );
};

export default CardGrid;
